import css from 'styled-jsx/css';

const styles = css.global`#em-dia-vale-mais-footer {
  background-color: #222222;
  padding: 40px 0 32px;
}

#em-dia-vale-mais-footer .footer-categories {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

#em-dia-vale-mais-footer .footer-column {
  display: flex;
  flex-direction: column;
}

#em-dia-vale-mais-footer .footer-topic {
  color: #fff;
  font-family: 'SantanderHeadline';
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 12px;
}

#em-dia-vale-mais-footer .footer-link {
  color: #fff;
  font-family: 'SantanderText';
  font-size: 14px;
  font-weight: 400;
  line-height: 32px;
  text-decoration: underline;
}

#em-dia-vale-mais-footer .footer-bottom {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #444;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#em-dia-vale-mais-footer .footer-logo img {
  height: 20px;
  filter: brightness(0) invert(1);
}

#em-dia-vale-mais-footer .footer-legal {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

#em-dia-vale-mais-footer .footer-legal span {
  color: #ccc;
  font-family: 'SantanderMicroText';
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}

@media (min-width: 992px) {
  #em-dia-vale-mais-footer {
    padding: 56px 0 40px;
  }

  #em-dia-vale-mais-footer .footer-categories {
    flex-direction: row;
    justify-content: space-between;
    gap: 24px;
  }

  #em-dia-vale-mais-footer .footer-column {
    flex: 1;
  }

  #em-dia-vale-mais-footer .footer-topic {
    font-size: 24px;
    margin-bottom: 16px;
  }

  #em-dia-vale-mais-footer .footer-link {
    font-size: 16px;
  }

  #em-dia-vale-mais-footer .footer-bottom {
    margin-top: 40px;
    padding-top: 32px;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  #em-dia-vale-mais-footer .footer-logo img {
    height: 24px;
  }

  #em-dia-vale-mais-footer .footer-legal {
    align-items: flex-end;
    text-align: right;
  }
}
`;

export default styles;